import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MdcDialogHeaderComponent, SharedUiModule } from '@mode/shared/ui';

import { SessionLoggedOutDialogComponent } from './session-logged-out-dialog/session-logged-out-dialog.component';
import { ButtonComponent } from '@mode/capra';

@NgModule({
  imports: [ButtonComponent, CommonModule, SharedUiModule, MatDialogModule, MdcDialogHeaderComponent],
  declarations: [SessionLoggedOutDialogComponent],
})
export class SessionsFeatureSessionModule {}
